/**
 * @module:  职位相关
 * @author: Liang Huang
 * @date: 2019-09-25 14:54:55
 */
import { observable, action, flow } from 'mobx';
import { Job, JobLocation } from '../../entity/resident/job';
import { ajax } from '@clouderwork/ywk';
import { Toast } from 'antd-mobile';
import { withRole } from '@src/utils/residentNew';
export function addressByLocation(location: JobLocation) {
  if (!location) return '';
  if (location.location_name === '不限') return '地点不限';
  return location.location_name === location.parent_name
    ? location.parent_name
    : `${location.parent_name}-${location.location_name}`;
}

interface CompJobsParams {
  offer_prop: string;
  company: number;
  offer_uuid: string;
  pagenum: number;
  pagesize: 999;
}

interface SendResumeParams {
  offer_uuid: string; // 职位uuid
  resume_uuids?: string; // 多个简历uuid用逗号拼接（在服务商身份可以进行批量投递）
  receiver_emails?: string; // 服务商身份接收通知邮箱（多个邮箱用逗号拼接）
  rtype?: number; // 1 在线简历 2 附件简历
}

class Offer {
  @observable curJob!: Job;
  @observable jobs: Job[] = [];
  @observable sendState: string = 'init';
  @observable submitState: string = 'init';
  // 获取职位详情
  @action.bound
  getJobDetail = flow(function* (this: Offer, uuid: string, fromEnt: boolean = false) {
    this.sendState = 'pending';
    try {
      // 文档地址 http://39.107.108.1:9098/resident/docs/offers/offer/
      const res = yield ajax.getJson(`/resident/api/offers/${uuid}`, withRole({}, fromEnt ? 1 : 2));
      this.sendState = 'done';
      if (+res.error_code === 0) {
        this.curJob = res.offer;
      } else {
        Toast.fail(res.message);
      }
      return res;
    } catch (error) {
      Toast.fail('offer请求失败');
      this.sendState = 'error';
      return error;
    }
  });

  // 获取公司当前在招职位
  @action.bound
  getCompanyJobs = flow(function* (this: Offer, params: CompJobsParams, fromEnt: boolean = false) {
    try {
      const res = yield ajax.getJson(`/resident/api/offers`, withRole(params, fromEnt ? 1 : 2));
      if (+res.error_code === 0) {
        this.jobs = res.offers;
      } else {
        Toast.fail(res.message);
      }
      return res;
    } catch (error) {
      Toast.fail('offers请求失败');
      return error;
    }
  });
  // 投递简历
  @action.bound
  sendResume = flow(function* (this: Offer, resume: SendResumeParams) {
    this.submitState = 'pending';
    try {
      const res = yield ajax.postJson(`/resident/api/delivery`, withRole(resume, 2));
      this.submitState = 'done';
      return res;
    } catch (error) {
      this.submitState = 'error';
      return error;
    }
  });
  // 黄豆纳才-立即沟通-发送职位信息
  @action.bound
  sendJobDetail = flow(function* (
    this: Offer,
    params: {
      data: Job; // 消息内容(json格式)
      from_usergroup_id: string; // HR所在企业的唯一编号
      interviewer_id: string; // HR的用户唯一编号
      applicant_id: string; //应聘者的用户唯一编号
      push_content?: string;
    }
  ) {
    try {
      return yield ajax.post('/wokexin/api/v1/message.zhaopin.office', withRole(params, 2));
    } catch (error) {}
  });
}

export default Offer;
